type PhoneIconProps = {
  className: string
}

export const PhoneIcon = ({ className }: PhoneIconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.6875 10.1875L7.74711 7.70899L6.82575 4H3.601C3.29388 6.00903 3.50886 10.7689 6.82575 13.7361C8.07971 14.8579 9.33368 15.5979 10.5112 16.0846C13.227 17.207 15.536 16.9815 16.5 16.9815V13.7361L12.8146 12.3452C12.5791 12.7275 11 15.75 11 15.75"
      stroke="#938E86"
      strokeWidth="1.85"
      strokeLinecap="round"
    />
  </svg>
)
